import { handleSubmitItem } from "./handleSubmitItem"; // Adjust the path if needed
import { DISABLE_USER_URL, ENABLE_USER_URL } from "../utils/endpoints";
import api from "../utils/api";

export const handleUserStateChange = async (
  id: number,
  isActive: boolean,
  addToast: (options: {
    title: string;
    description: string;
    status: "success" | "error";
  }) => void,
  fetchData?: () => void,
) => {
  const bodyRequest = { id };

  const success = isActive
    ? await handleSubmitItem(
        () => api.patch(DISABLE_USER_URL, bodyRequest),
        addToast,
      )
    : await handleSubmitItem(
        () => api.patch(ENABLE_USER_URL, bodyRequest),
        addToast,
      );

  if (success && fetchData) {
    fetchData();
  }
};
